import {getSwiperAssetsV2} from '@pernod-ricard-global-cms/jsutils';
import('swiper/css/bundle');

export default function siteHeaderJs(options = {}) {
	try {
		// CSS for site-header should usually be included in critical.scss
		const {block} = options;
		let navCarouselLoaded = false;
		function navCarousel() {
			Promise.all([getSwiperAssetsV2()]).then((values) => {
				const {Swiper, Navigation} = values[0][0];
				console.log('🚀 ~ siteHeaderJs ~ block:', Swiper);

				const navMenuSwiper = new Swiper(
					block.querySelector('.nav-menu-carousel'),
					{
						modules: [Navigation],
						slidesPerView: 1.3,
						spaceBetween: 15,
						centeredSlides: true,
						loop: true,
						breakpoints: {
							768: {
								slidesPerView: 1.3
							}
						},

						navigation: {
							nextEl: block.querySelector('.swiper-button-next'),
							prevEl: block.querySelector('.swiper-button-prev')
						}
					}
				);
			});
		}
		// fadeIn(block);
		const documentBody = document.body;
		const header = document.querySelector('.site-header');
		const navContainer = document.querySelector('.header-nav');
		const hamburgerWrapper = document.querySelector(
			'.header-interactions__hamburger-wrapper'
		);
		const hamburger = document.querySelector(
			'.header-interactions__hamburger'
		);
		const hamburgerBars = hamburger.querySelectorAll(
			'.header-interactions__hamburger-bar'
		);
		const crossBars = document.querySelectorAll(
			'.nav-interactions__cross-bar'
		);
		const outerContainer = navContainer.querySelector(
			'.header-nav__outer-container'
		);
		const itemsWithChildren = navContainer.querySelectorAll(
			'.header-nav__item-main.menu-item-has-children'
		);
		const subNavs = navContainer.querySelectorAll('.header-nav__sub-nav');
		const subNavClose = navContainer.querySelectorAll(
			'.header-nav__sub-nav-close'
		);
		const navWrapper = document.querySelector('.site-header__nav-wrapper');
		const closeMenu = document.querySelector('.nav-interactions__cross');

		const toggleMenu = () => {
			if (!navCarouselLoaded) {
				navCarousel();
				navCarouselLoaded = true;
			}
			hamburger.classList.toggle('active');
			navWrapper.classList.toggle('active');
			outerContainer.classList.toggle('active');
			hamburgerBars.forEach((item) => {
				item.classList.toggle('active');
			});
			crossBars.forEach((item) => {
				item.classList.toggle('active');
			});
			documentBody.classList.toggle('menu-active');
			if (outerContainer.classList.contains('subnav-active')) {
				outerContainer.classList.remove('subnav-active');
			}

			subNavs.forEach((item) => {
				if (item.classList.contains('active')) {
					item.classList.remove('active');
				}
			});
		};

		const wrapperClick = (event) => {
			if (
				event.target.classList.contains('site-header__nav-wrapper') &&
				event.target.classList.contains('active')
			) {
				toggleMenu();
			}
		};

		hamburgerWrapper.addEventListener('click', toggleMenu);
		closeMenu.addEventListener('click', toggleMenu);
		navWrapper.addEventListener('click', wrapperClick);

		itemsWithChildren.forEach((item) => {
			item.addEventListener('click', function (e) {
				item.classList.toggle('active');
				outerContainer.classList.toggle('subnav-active');
				item.parentNode
					.querySelector('.header-nav__sub-nav')
					.classList.toggle('active');
			});
		});

		subNavClose.forEach((item) => {
			const dropDown = item.parentNode.parentNode.querySelector(
				'.header-nav__item-with-children'
			);
			item.addEventListener('click', function (e) {
				dropDown.classList.toggle('active');
				outerContainer.classList.toggle('subnav-active');
				item.parentNode.classList.toggle('active');
			});
		});

		const detectScrolling = () => {
			if (
				window.scrollY > 10 &&
				!header.classList.contains('scrolling')
			) {
				header.classList.add('scrolling');
			} else if (
				window.scrollY < 10 &&
				header.classList.contains('scrolling')
			) {
				header.classList.remove('scrolling');
			}
		};

		window.addEventListener('scroll', detectScrolling, false);
	} catch (error) {
		console.error(error);
	}
}
